import { Injectable, Injector } from '@angular/core';

import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { CategoriaIconeModel } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CategoriaIconeService extends BaseCrudService<CategoriaIconeModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'CategoriaIcone';
  }

  getAll(): Observable<CategoriaIconeModel[]> {
    return this
      .httpClient
      .get<CategoriaIconeModel>(`${this.getApiUrl()}${this.getController()}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
